module.exports = __webpack_public_path__ + "static/brittan-canyon-bb76845b09b75f01284162c9d359a0c7.jpg";